/** feedback actions constants */
export const SET_FEEDBACK_LIST = 'ProductDetails::Body::SetFeedbacksList';
export const SET_FEEDBACK_TOTAL_COUNT = 'ProductDetails::Body::SetFeedbacksCount';
export const SET_FEEDBACK_PAGE_NUMBER = 'ProductDetails::Body::SetFeedbacksCurrentPageNumber';
export const SET_FEEDBACK_SORT_BY = 'ProductDetails::Body::SetFeedbackSortBy';
